import "./setup/firebase";

/* Global definitions -- START */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _global = ( window || global ) as any;

declare global {
    function isDefined<T>( value: T ): value is NonNullable<T>;
}

_global.isDefined = <T>( value: T ): value is NonNullable<T> => {
    return value !== undefined && value !== null;
};

/* Global definitions -- END */

// Enable toggling HID request logging from the browser console
import { setHidRequestLogging } from "connections/hid";
_global.setHidLogging = ( enabled: boolean ) => setHidRequestLogging( enabled );

export {};
